import { ServicePartnerTagFormData } from "@rumble-it/common-lib/types/models/ServicePartnerTag.interface";
import { useMutation } from "@tanstack/react-query";
import { Col, Form, message, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { ServicePartnerTagFormCard } from "./components/ServicePartnerTagFormCard";
import { createServicePartnerTag } from "@/lib/api/resources/servicePartnerTags.ts";

export const ServicePartnerTagCreate = () => {
  const navigate = useNavigate();

  const [form] = Form.useForm<ServicePartnerTagFormData>();

  const createServicePartnerTagMutation = useMutation({
    mutationFn: (data: ServicePartnerTagFormData) =>
      createServicePartnerTag(data),
    onSuccess: () => {
      navigate(`/service-partners/tags`);
      message.success("Tag succesvol aangemaakt");
    },
    onError: () =>
      message.error("Er is een fout opgetreden bij het aanmaken van de tag"),
  });

  const handleFinish = (values: ServicePartnerTagFormData) => {
    createServicePartnerTagMutation.mutate(values);
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical">
      <Row gutter={[16, 16]}>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnerTagFormCard
            title="Tag aanmaken"
            buttonText="Aanmaken"
            submitting={createServicePartnerTagMutation.isPending}
          />
        </Col>
      </Row>
    </Form>
  );
};
